import { queries } from "lib/build/dashboards/shared";

import { useLastEventValueByQuery } from "src/features/events";

export function useSocialSecurityNumber(): string | undefined {
	return useLastEventValueByQuery<string>(queries.socialSecurityNumber);
}
